/**
 * Init dropdown/popover for actions or reschedule.
 * callbacks: { initPopoverContentLinks(), initAsyncLinkLoaders(container), refreshLucideIcons() }
 */
export function initPopover(popup, selector, callbacks = {}) {
  const popoverWrap = popup.querySelector(selector);
  const actionsTrigger = popoverWrap?.querySelector('.js-popover-link');
  const actionsContent = popoverWrap?.querySelector('.js-popover-content');

  if (!actionsTrigger || !actionsContent || typeof SMDropdown === 'undefined') {
    return;
  }

  if (actionsTrigger.dataset.dropdownInitialized === 'true') {
    return;
  }

  SMDropdown.init(actionsTrigger, {
    content: actionsContent.outerHTML,
    zIndex: 12050,
    onCreate: function(instance) {
      if (instance && instance.popper) {
        instance.popper.classList.add('showing-view-popup__dropdown');
      }
    },
    onShown: () => {
      document.dispatchEvent(new CustomEvent('dashboard:init-popover-links'));
      callbacks.initPopoverContentLinks?.();
      const tippyRoot = document.querySelector('[data-tippy-root]');
      if (tippyRoot) callbacks.initAsyncLinkLoaders?.(tippyRoot);
      callbacks.refreshLucideIcons?.();
    }
  });

  actionsTrigger.dataset.dropdownInitialized = 'true';
}
